var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_2023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3C18.3065 3 17.1619 3.47411 16.318 4.31802C15.4741 5.16193 15 6.30653 15 7.5V9H4.5C3.30653 9 2.16193 9.47411 1.31802 10.318C0.474106 11.1619 0 12.3065 0 13.5L0 37.5C0 38.6935 0.474106 39.8381 1.31802 40.682C2.16193 41.5259 3.30653 42 4.5 42H43.5C44.6935 42 45.8381 41.5259 46.682 40.682C47.5259 39.8381 48 38.6935 48 37.5V13.5C48 12.3065 47.5259 11.1619 46.682 10.318C45.8381 9.47411 44.6935 9 43.5 9H33V7.5C33 6.30653 32.5259 5.16193 31.682 4.31802C30.8381 3.47411 29.6935 3 28.5 3H19.5ZM19.5 6H28.5C28.8978 6 29.2794 6.15804 29.5607 6.43934C29.842 6.72064 30 7.10218 30 7.5V9H18V7.5C18 7.10218 18.158 6.72064 18.4393 6.43934C18.7206 6.15804 19.1022 6 19.5 6ZM25.158 26.742L45 21.453V37.5C45 37.8978 44.842 38.2794 44.5607 38.5607C44.2794 38.842 43.8978 39 43.5 39H4.5C4.10218 39 3.72064 38.842 3.43934 38.5607C3.15804 38.2794 3 37.8978 3 37.5V21.45L22.842 26.742C23.6008 26.9441 24.3992 26.9441 25.158 26.742ZM4.5 12H43.5C43.8978 12 44.2794 12.158 44.5607 12.4393C44.842 12.7206 45 13.1022 45 13.5V18.348L24.387 23.844C24.1334 23.9117 23.8666 23.9117 23.613 23.844L3 18.348V13.5C3 13.1022 3.15804 12.7206 3.43934 12.4393C3.72064 12.158 4.10218 12 4.5 12Z",
    fill: "#799AA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_2023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.7fb9e7417fd46a5a993da97aea129f2d.svg";
export { ForwardRef as ReactComponent };